import { render, staticRenderFns } from "./SeminarOrderDocs.vue?vue&type=template&id=410b7ba3"
import script from "./SeminarOrderDocs.vue?vue&type=script&lang=js"
export * from "./SeminarOrderDocs.vue?vue&type=script&lang=js"
import style0 from "./SeminarOrderDocs.vue?vue&type=style&index=0&id=410b7ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports